
export const product_category = `
{
    title
    seo {
        url
        full_url
    }
    custom_fields
    parents {
        title
        seo {
            url
            full_url
        }
    }
}
`

export const category_search_page = `
{
  id
  title
  description
  parents {
    seo {
      url
      full_url
    }
    title
  }
  seo {
    url
    full_url
  }
}
`

export const category_search_page_with_widgets = `
{
  id
  title
  description
  seo {
    url
    full_url
  }
  widgets {
    section
    widgets {
      widget_id
      widget_component_key
      fields
      
    }
  }
}
`